import { useMutation, useQueryClient } from '@tanstack/react-query'
import { showNotification } from '@mantine/notifications'
import { useOrpc } from './useClient'
import { tefcaOpenReviewQueryKey } from './useTefcaManualLink'
import { logError } from '@/utils/errorUtils'

/**
 * Manual Create resolution of a Match Review: calls the TEFCA manual-create
 * endpoint, which creates the Health Gorilla record from the chart
 * demographics verbatim, links it, completes the pending review, and starts
 * the standard historical import.
 */
export function useTefcaManualCreate(options?: { onSuccess?: () => void }) {
  const orpc = useOrpc()
  const queryClient = useQueryClient()

  return useMutation(
    orpc.tefcaManualCreate.mutationOptions({
      onSuccess: async (_data, variables) => {
        showNotification({
          color: 'green',
          message: 'TEFCA record created and linked. Importing outside records…',
        })
        await queryClient.invalidateQueries({
          queryKey: tefcaOpenReviewQueryKey(variables.patientId),
        })
        options?.onSuccess?.()
      },
      onError: (error) => {
        logError('patient', 'TEFCA manual create', error)
        showNotification({
          color: 'red',
          message: 'Failed to create the TEFCA record. Please try again.',
        })
      },
    }),
  )
}
